import React, { Component } from 'react';
import { connect } from 'react-redux';
import { translate } from "../../translate";

import { ChartCollumns, ChartDoughnut } from "../../components/Charts"
import Loading from "../../components/Loading"
import API from "../../api";
import TemplateDefault from "../Templates/Default";

import "./style.css";
// import imgBG from "../../../assets/images/bg-full.jpg";


class Home extends Component {
    constructor( props ) {
        super( props );
        this.state = {
            loading: false,
            meusLeads: [],
            leads: [],
            count_leads: 0,
            // grafico_1: { loaded: true, labels: ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'], data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0] },//12 meses

            grafico_1: {
                loaded: false,
                chartData: {
                    labels: ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'],
                    datasets: [{
                        label: 'Abertos',
                        data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
                        backgroundColor: "yellow",
                        borderWidth: 0
                    },
                    {
                        label: 'Cliente',
                        data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
                        backgroundColor: 'green',
                        borderWidth: 0
                    },
                    {
                        label: 'Perdidos',
                        data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
                        backgroundColor: 'red',
                        borderWidth: 0
                    }
                    ]
                },
                },

                grafico_2: { loaded: false, labels: ['Abertos', 'Trabalhando', 'Cliente', 'Perdidos'], data: [0, 0, 0, 0] }
            }

           // API.setImageBackground(imgBG);
        }
        componentDidMount() {
            this.loadData();
        }

        composer = (...fns) => value => fns.length ? fns.reduceRight((previousValue, fn) => fn(previousValue), value) : value;

        loadData = async () => {

            let allLeads = await this.getAllLeads();
            let meusLeads = await this.getMeuLeads();
            

            let all_abertos = allLeads => {
                return allLeads.filter( f => Boolean( f.estagio === "A" || !!!f.estagio || f.estagio === "L") );// Abertos
            }

            let all_trabalhando  = allLeads => {
                return allLeads.filter( f => Boolean( f.estagio === "T" ) );// Trabalhando
            }

            let all_clientes = allLeads => {
                return allLeads.filter( f => Boolean( f.estagio === "C") );// Cliente
            }
            
            let all_perdidos = allLeads => {
                return allLeads.filter( f => Boolean( f.estagio === "P") );// Perdidos
            }
            
            let getFullYear = dataentrada => {
                return new Date( `${dataentrada} 00:00:00` ).getFullYear()
            }

            let getMonth = dataentrada => {
                return new Date( `${dataentrada} 00:00:00` ).getMonth()
            }

            allLeads = allLeads.concat( meusLeads ).filter(l => getFullYear(l.dataentrada) === new Date().getFullYear()) // dados desse ano apenas
            let months_data = []; /// Dados para o grafio de Barras por mes

            for (let index = 0; index < 12; index++) {
                var leads_this_month = allLeads.filter(l => getMonth(l.dataentrada) === index)

                months_data[index] = {
                    total_abertos : this.composer(all_abertos)(leads_this_month).length,
                    total_clientes : this.composer(all_clientes)(leads_this_month).length,
                    total_perdidos : this.composer(all_perdidos)(leads_this_month).length
                }
            } 

            allLeads = allLeads.map( lead => {

                let indexmonth = getMonth(lead.dataentrada)

                this.setState( state => {


                    state.grafico_1.chartData.datasets[0]["data"][indexmonth] = months_data[indexmonth].total_abertos // Abertos
                    state.grafico_1.chartData.datasets[1]["data"][indexmonth] = months_data[indexmonth].total_clientes // Cliente
                    state.grafico_1.chartData.datasets[2]["data"][indexmonth] = months_data[indexmonth].total_perdidos // Perdidos


                    return state;

                } )

                return { estagio: lead.estagio, dataentrada: lead.dataentrada }
            } );


            this.setState( state => {

                state.count_leads = this.composer(all_abertos)(allLeads).length;

                state.grafico_2.data[0] = this.composer(all_abertos)(allLeads).length //Abertos
                state.grafico_2.data[1] = this.composer(all_trabalhando)(allLeads).length;// Trabalhando
                state.grafico_2.data[2] = this.composer(all_clientes)(allLeads).length;// Cliente
                state.grafico_2.data[3] = this.composer(all_perdidos)(allLeads).length// Perdidos



                state.grafico_1.loaded = true;
                state.grafico_2.loaded = true;




                return state;

            } )


        }

        getAllLeads = () => {
            return new Promise( ( resolve, reject ) => {
                this.setState( {
                    loading: true
                } );

                API.get( "/leads" ).then( async r => {
                    let data = Object.values( r.data );

                    this.setState( state => {

                        state.leads = data;
                        state.loading = false;


                        return state;
                    } );


                    resolve( data )

                }, error => {

                    this.setState( {
                        leads: [],
                        loading: false
                    } );
                    reject( [] )
                } )
            } )

        }

        getMeuLeads = () => {
            return new Promise( ( resolve, reject ) => {
                this.setState( {
                    loading: true
                } );

                API.post( "/meusleads", { idusuario: this.props.activeUser.id } ).then( async r => {

                    let data = Object.values( r.data );
                    this.setState( state => {

                        state.meusLeads = data;
                        state.loading = false;


                        return state;
                    } );



                    resolve( data )

                }, error => {

                    this.setState( {
                        loading: false
                    } );
                    resolve( [] )
                } )
            } )

        }


        render() {
            let { count_leads, grafico_1, grafico_2 } = this.state;

            return (
                <TemplateDefault custom_class="box-generic-2">
                    <div id="home">
                        {
                            this.state.loading ? (
                                <div className="row">
                                    <div className="col-sm-12 box-chart" >
                                        <div className="mt-20 mb-20" >
                                            <div className="col-sm 12 text-center" style={{ color: "#fff" }}>
                                                <Loading /> <span style={{ "fontSize": "20px", "margin": "20px" }}> {translate( "Carregando relatórios..." )}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ) : ""

                        }

                        <div className={`row ${!!!this.state.loading ? "" : "hide"}`}>

                            <div className="col-sm-6 box-chart" >
                                <div>
                                    {
                                        grafico_1.loaded ? (
                                            <ChartCollumns title='Entrada de Leads' datasets={grafico_1.chartData} />
                                        ) : ""
                                    }

                                </div>
                            </div>
                            <div className="col-sm-6 box-chart" >
                                <div>
                                    {
                                        grafico_2.loaded ? (
                                            <ChartDoughnut labels={grafico_2.labels} data={grafico_2.data} />
                                        ) : ""
                                    }


                                </div>
                                <div>
                                    {
                                        count_leads === 0 ? (<b style={{fontWeight: 500, color: "#1da91d" }}> <span className="glyphicon glyphicon-thumbs-up"></span> Parabéns!!! Nenhum lead em aberto para serem trabalhados. </b>) : (<span style={{fontWeight: 500, color: "#fafafa" }}> Existem <small style={{color:"red",fontSize:"18px"}}>{count_leads}</small> leads em abertos para serem trabalhados em menos de 12 horas. </span>)
                                    }
                                    
                                </div>
                            </div>
                        </div>
                    </div>
                </TemplateDefault>

            )
        }




    }


// "state" is set in reducers/index.js
function mapStateToProps( state ) {
    return {
        activeUser: state.activeUser
    };
}

export default connect( mapStateToProps )( Home );